module.exports = __webpack_public_path__ + "static/cmdtooltip-ad123ecffbeccbc7165f8671c77de2da.png";